import React, { useState, useEffect } from 'react'
import styles from './style/search-content-mod.module.less'
import {
  IconCopy,
  IconEditor2,
  IconSearch,
  IconPdf,
  IconContext,
  IconDownload,
  IconDetail,
  IconCalendar,
  IconSuccessTip,
  IconWarnTip,
  IconErrorTip,
} from '@arco-iconbox/react-aidb-v2'
import {
  Message,
  Input,
  BackTop,
  Tooltip,
  InputTag,
  DatePicker,
} from '@arco-design/web-react'
import { geTextSplitting, getNewsLibrarySearch } from './utils/api'
import { includeKeyWord } from './utils/utilsFunction'
import ModalCustom from '../../components/ModalCustom'
import TreeSelectMod from './TreeSelectMod'
import SearchTextMod from './SearchTextMod'
import SearchHistoryMod from './SearchHistoryMod'
import SearchExportMod from './SearchExportMod'
import PDF from './PDF'
import Empty from './Empty'
import Copy from '../Copy'
import useScrollToBottom from './utils/useScrollToBottom'
import fake1 from '../../assets/imgs/fake-tree1.jpg'

// 获取当前日期
const queryDate = (offset = 0) => {
  // 不足两位补零
  let addZero = (val) => (Number(val) < 10 ? '0' + val : val)

  // 获取当前日期
  let time = new Date()

  if (offset) {
    time.setDate(time.getDate() - offset)
  }

  let year = time.getFullYear(),
    month = time.getMonth() + 1,
    day = time.getDate(),
    week = time.getDay(),
    hour = time.getHours(),
    minutes = time.getMinutes(),
    seconds = time.getSeconds()
  // 拼接成想要的时间字符串
  // let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
  // let result = year + '年' + addZero(month) + '月' + addZero(day) + '日 '
  // result += weeks[week] + ' '
  // result += addZero(hour) + ':' + addZero(minutes) + ':' + addZero(seconds)
  let result = year + '-' + addZero(month) + '-' + addZero(day)
  return result
}

const NewsLibrary = (props) => {
  // 新闻库搜索中
  const [newsLibrarySearching, setNewsLibrarySearching] =
    useState<boolean>(false)
  // 详情显示弹窗
  const [visible, setVisible] = useState<boolean>(false)
  // 搜索记录弹窗
  const [historyVisible, setHistoryVisible] = useState<boolean>(false)
  // 导出所选弹窗
  const [exportVisible, setExportVisible] = useState<boolean>(false)
  // 内容源站值
  const [contentStationValue, setContentStationValue] = useState<string>('')
  // 内容源站ID值
  const [contentStationIdValue, setContentStationIdValue] = useState<string>('')
  // 新闻关键字
  const [newsKeywordsValue, setNewsKeywordsValue] = useState<string>('')
  // 正文关键字值拆分
  const [newsKeywordsArr, setNewsKeywordsArr] = useState<string[]>([])
  // 副标关键字
  const [subtitleKeywordsValue, setSubtitleKeywordsValue] = useState<string>('')
  // 时间段
  const [timeSlot, setTimeSlot] = useState<string[]>([
    queryDate(30),
    queryDate(),
  ])
  // 新闻库搜索数据
  const [newsLibrarySearchArray, setNewsLibrarySearchArray] = useState<any[]>(
    [],
  )
  // 新闻库搜索历史数据
  const [newsLibrarySearchHistoryData, setNewsLibrarySearchHistoryData] =
    useState<any[]>([])
  // 新闻库数据当前页数
  const [newsLibraryPage, setNewsLibraryPage] = useState<number>(0)
  // 正文内容
  const [mainContent, setMainContent] = useState<string>('')

  // 初始添加历史记录
  useEffect(() => {
    const newsLibraryHistoryList = JSON.parse(
      window.localStorage.getItem('newsLibraryHistoryList'),
    )
    newsLibraryHistoryList &&
      setNewsLibrarySearchHistoryData(newsLibraryHistoryList)
  }, [])

  // 存储历史记录
  useEffect(() => {
    window.localStorage.setItem(
      'newsLibraryHistoryList',
      JSON.stringify(newsLibrarySearchHistoryData),
    )
  }, [newsLibrarySearchHistoryData])

  // 新闻库点击搜索
  const getNewsLibrarySearchBack = (
    page: number,
    stationValue: string,
    stationId: string,
    newsKeywords: string,
    subtitleKeywords: string,
    timeSlot: string[],
    isAgainSearch?: boolean,
  ) => {
    if (newsLibrarySearching) {
      Message.warning({
        icon: <IconWarnTip useCurrentColor={false} />,
        content: '正在搜索中，请勿重复点击！',
      })
      return
    }

    setNewsLibraryPage(0)
    newsLibrarySearchArray.length && setNewsLibrarySearchArray([])
    // loading
    setNewsLibrarySearching(true)
    if (isAgainSearch === true) {
      setContentStationValue(stationValue)
      setContentStationIdValue(stationId)
      setNewsKeywordsValue(newsKeywords)
      setSubtitleKeywordsValue(subtitleKeywords)
      setTimeSlot(timeSlot)
    } else {
      // 添加历史记录
      pushNewsLibraryHistory()
    }

    // 发送请求
    getNewsLibrarySearchData(
      0,
      stationId,
      newsKeywords,
      subtitleKeywords,
      timeSlot,
    ).then((data: []) => {
      setNewsLibrarySearchArray(data)
    })
  }

  // 滚动到底部加载
  const scrollToBottomRef = useScrollToBottom(() => {
    if (newsLibrarySearching || !newsLibrarySearchArray.length) return

    // loading
    setNewsLibrarySearching(true)
    // 发送数据

    // 发送请求
    getNewsLibrarySearchData(
      newsLibraryPage,
      contentStationIdValue,
      newsKeywordsValue,
      subtitleKeywordsValue,
      timeSlot,
    ).then((data: []) => {
      setNewsLibrarySearchArray([...newsLibrarySearchArray, ...data])
    })
  })

  // 添加历史记录
  const pushNewsLibraryHistory = () => {
    setNewsLibrarySearchHistoryData((historyData) => {
      return [
        {
          station: {
            contentStationValue,
            contentStationIdValue,
          },
          newsKeywordsValue,
          subtitleKeywordsValue,
          timeSlot,
        },
        ...historyData,
      ]
    })
  }

  // 删除某条历史记录
  const removerNewsLibraryHistory = (index: number) => {
    setNewsLibrarySearchHistoryData((historyData) =>
      historyData.filter((_, i) => i !== index),
    )
  }

  // 发送请求
  const getNewsLibrarySearchData = (
    page,
    stationId,
    newsKeywords,
    subtitleKeywords,
    timeSlot,
  ) => {
    return new Promise((resolve, reject) => {
      // 将关键字空格改为‘_’
      geTextSplitting(newsKeywords)
        .then((keyWord) => {
          let keyWords = keyWord.replace(/\s/g, '_')
          setNewsKeywordsArr(keyWords.split('_'))
          // 搜索请求
          getNewsLibrarySearch({
            page,
            stationId,
            newsKeywords: keyWords,
            subtitleKeywords,
            timeSlot,
          })
            .then((res) => {
              let result = JSON.parse(res.data)
              // console.log(result)

              if (res.status == 200) {
                resolve(result)
                if (result.length) {
                  Message.success({
                    icon: <IconSuccessTip useCurrentColor={false} />,
                    content: '搜索数据成功！',
                  })
                  // 页数+1
                  setNewsLibraryPage((page) => {
                    return (page += 1)
                  })
                } else {
                  Message.warning({
                    icon: <IconWarnTip useCurrentColor={false} />,
                    content: '此搜索暂无数据！',
                  })
                }
              } else {
                Message.error({
                  icon: <IconErrorTip useCurrentColor={false} />,
                  content: '搜索失败，请重试！',
                })
              }
              setNewsLibrarySearching(false)
            })
            .catch((err) => {
              setNewsLibrarySearching(false)
              Message.error({
                icon: <IconErrorTip useCurrentColor={false} />,
                content: '搜索失败，请重试！',
              })
              console.log(err)
            })
        })
        .catch((err) => {
          setNewsLibrarySearching(false)
          Message.error({
            icon: <IconErrorTip useCurrentColor={false} />,
            content: '搜索失败，请重试！',
          })
          console.log(err)
        })
    })
  }

  return (
    <div className={styles.searchContent}>
      {/*搜索条件*/}
      <div className={styles.searchForm}>
        <div className={styles.title}>
          <h3>搜索条件</h3>
          <p>
            小贴士：缩小搜索范围，将获得更快更精确的内容，如等待时间过长请保存后刷新
          </p>
        </div>
        <div className={styles.box}>
          <div className={styles.formWrap}>
            <div className={styles.formItem}>
              <div className={styles.label}>内容源站：</div>
              <div className={styles.con}>
                <TreeSelectMod
                  category="CONTENT_STATION_VALUE"
                  disabled={newsLibrarySearching}
                  value={contentStationValue}
                  setValue={setContentStationValue}
                  idValue={contentStationIdValue}
                  setIdValue={setContentStationIdValue}
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>新闻关键字：</div>
              <div className={styles.con}>
                <Input
                  className={'red-input'}
                  disabled={newsLibrarySearching}
                  value={newsKeywordsValue}
                  onChange={setNewsKeywordsValue}
                  allowClear
                  height={40}
                  placeholder=""
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>（副标）关键字：</div>
              <div className={styles.con}>
                <Input
                  className={'red-input'}
                  disabled={newsLibrarySearching}
                  value={subtitleKeywordsValue}
                  onChange={setSubtitleKeywordsValue}
                  allowClear
                  height={40}
                  placeholder=""
                />
              </div>
            </div>
            <div className={styles.formItem}>
              <div className={styles.label}>时间段：</div>
              <div className={`${styles.con} ${'datePickerWrap'}`}>
                <DatePicker.RangePicker
                  disabled={newsLibrarySearching}
                  value={timeSlot}
                  onChange={setTimeSlot}
                  style={{
                    // width: 165,
                    height: 40,
                  }}
                  prefix={<IconCalendar />}
                />
              </div>
            </div>
          </div>
          <div className={styles.formBot}>
            <div className={styles.left}>
              <div
                className={styles.btn}
                onClick={() =>
                  getNewsLibrarySearchBack(
                    newsLibraryPage,
                    contentStationValue,
                    // contentStationIdValue.split('_')[0],
                    contentStationIdValue,
                    newsKeywordsValue,
                    subtitleKeywordsValue,
                    timeSlot,
                  )
                }>
                <div className={styles.icon}>
                  <IconSearch useCurrentColor={true} />
                </div>
                <div className={styles.txt}>搜索</div>
              </div>
              <div
                className={styles.txtBtn}
                onClick={() => {
                  setTimeSlot([queryDate(30), queryDate()])
                  setContentStationValue('')
                  setContentStationIdValue('')
                  setNewsKeywordsValue('')
                  setSubtitleKeywordsValue('')
                }}>
                重置
              </div>
            </div>
            <div className={styles.right}>
              <div
                className={styles.txtBtn}
                onClick={() => {
                  setHistoryVisible(true)
                }}>
                搜索记录
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*搜索结果*/}
      <div className={styles.searchResult}>
        <div className={styles.title}>搜索结果：</div>
        <div
          id="custom_backTop"
          className={styles.resultList}
          ref={scrollToBottomRef}>
          {newsLibrarySearchArray.length ? (
            newsLibrarySearchArray.map((item, index) => {
              return (
                item.news && (
                  <div className={styles.item} key={index}>
                    <div className={styles.top}>
                      <div className={styles.index}>{index + 1}.</div>
                      <div className={`${styles.info} ${styles.single}`}>
                        <div className={styles.box}>
                          <div className={styles.type}>标题</div>
                          <div className={styles.con}>
                            <Tooltip content={item.news.properties.title}>
                              {item.news.properties.title}
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.bot}>
                      <div className={styles.left}></div>
                      <div className={styles.right}>
                        <div className={styles.subTit}>
                          <p>
                            {item.news.properties.subTitle
                              ? `副标：${item.news.properties.subTitle}`
                              : ''}
                          </p>
                          <p>
                            {item.news.properties.source
                              ? `来源：${item.news.properties.source}`
                              : ''}
                          </p>
                        </div>
                        <div
                          className={styles.text}
                          onClick={() => {
                            setMainContent(item.news.properties.contentRaw)
                            setVisible(true)
                          }}
                          dangerouslySetInnerHTML={{
                            __html: newsKeywordsValue
                              ? includeKeyWord(
                                  item.news.properties.contentRaw,
                                  newsKeywordsArr,
                                )
                              : item.news.properties.contentRaw,
                          }}></div>
                        <div className={styles.btnGroup}>
                          <div className={styles.l}>
                            <div
                              className={styles.btn}
                              onClick={() => {
                                setMainContent(item.news.properties.contentRaw)
                                setVisible(true)
                              }}>
                              <div className={styles.icon}>
                                <IconEditor2 useCurrentColor={true} />
                              </div>
                              <div className={styles.txt}>编辑</div>
                            </div>
                            <Copy
                              className={styles.btn}
                              text={item.news.properties.contentRaw}
                              onCopy={() => {
                                Message.success({
                                  icon: (
                                    <IconSuccessTip useCurrentColor={false} />
                                  ),
                                  content: '复制成功！',
                                })
                              }}
                              content={
                                <>
                                  <div className={styles.icon}>
                                    <IconCopy useCurrentColor={true} />
                                  </div>
                                  <div className={styles.txt}>复制</div>
                                </>
                              }
                            />
                            <div
                              className={styles.btn}
                              onClick={() => {
                                setExportVisible(true)
                              }}>
                              <div className={styles.icon}>
                                <IconDownload useCurrentColor={true} />
                              </div>
                              <div className={styles.txt}>导出</div>
                            </div>
                          </div>
                          <div className={styles.r}>
                            <div
                              className={`${styles.btn} ${styles.noBorder}`}
                              onClick={() =>
                                window.open(item.news.properties.url, '_blank')
                              }>
                              <div className={styles.icon}>
                                <IconDetail />
                              </div>
                              <div className={styles.txt}>原文</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )
            })
          ) : (
            <Empty title="暂无数据！" state={newsLibrarySearching} />
          )}

          {/* 加载更多 */}
          {newsLibrarySearching && newsLibrarySearchArray.length ? (
            <div className={styles.scrollToBottom}>正在加载更多......</div>
          ) : (
            ''
          )}
        </div>
      </div>

      {/* 返回顶部 */}
      <BackTop
        visibleHeight={30}
        style={{ position: 'absolute', right: '5px' }}
        target={() => document.getElementById('custom_backTop')}
      />

      {/*正文内容*/}
      <ModalCustom
        width={'650px'}
        className={styles.textPop}
        title={null}
        visible={visible}
        close={() => setVisible(false)}
        content={
          <SearchTextMod
            setVisible={setVisible}
            content={mainContent ? mainContent : '无详细资料！'}
            keyWord={newsKeywordsValue}
          />
        }
      />

      {/*搜索记录*/}
      <ModalCustom
        width={'700px'}
        className={styles.textPop}
        title={null}
        visible={historyVisible}
        close={() => setHistoryVisible(false)}
        content={
          <SearchHistoryMod
            category="NEW_LIBRARY"
            page={newsLibraryPage}
            setPage={setNewsLibraryPage}
            setHistoryVisible={setHistoryVisible}
            removerHistory={removerNewsLibraryHistory}
            historyData={newsLibrarySearchHistoryData}
            setHistoryData={setNewsLibrarySearchHistoryData}
            getSearchBack={getNewsLibrarySearchBack}
          />
        }
      />

      {/*导出所选*/}
      <ModalCustom
        width={'550px'}
        className={styles.textPop}
        title={null}
        visible={exportVisible}
        close={() => setExportVisible(false)}
        content={
          <SearchExportMod
            visible={exportVisible}
            setVisible={setExportVisible}
            contentStationIdValue={contentStationIdValue}
            newsKeywordsValue={newsKeywordsValue}
            subtitleKeywordsValue={subtitleKeywordsValue}
            timeSlot={timeSlot}
          />
        }
      />
    </div>
  )
}

export default NewsLibrary
